<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{ $t("coupon_code.label") }}
        </div>
        <span class="body-1 greyDarken1--text">{{
          $t("coupon_code.label.list.subtitle")
        }}</span>
      </div>
      <v-spacer></v-spacer>
      <CouponCreate :dialog.sync="dialog" @getCouponsList="getCouponsList(1)"></CouponCreate>
      <v-btn color="secondary" dark class="mx-0" @click="dialog = true">
        <v-icon small>$vuetify.icons.rms_create</v-icon>
        {{ $t("rms.button.create") }}
      </v-btn>
       <v-btn @click="exportCoupons" color="primary" class="mr-0">
        <v-icon small class="pr-1">$vuetify.icons.rms_media_download</v-icon>
        {{$t('screener.export.title')}}
      </v-btn>
    </v-card-title>
      <v-layout row wrap class="pa-3">
        <v-flex xs12 sm3 md3>
          <v-text-field
            append-outer-icon="search"
            v-model="search"
            :placeholder="$t('rms.field.search')"
            clear-inner-icon="rms_close"
            clearable
            single-line
            hide-details
            @click:clear="clearSearch"
            @click:append-outer="applySearch"
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 sm2 md2>
          <v-select
              v-model="status"
              :items="DEFINES.COUPON_STATUS"
              :label="$t('Coupon Status')"
              item-text="text"
              item-value="value"
              @input="getCouponsList(1)"
              class="pr-2"
            ></v-select>
        </v-flex>
        <v-flex xs12 sm4 md4 pl-2>
          <v-layout row wrap class="text-xs-right">
          <!-- From date -->
          <v-flex xs12 sm12 md5 pr-2>
            <v-menu
              v-model="fromDateMenu"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              color="primary"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="fromDate"
                  label="Start Date"
                  readonly
                  color="primary"
                  v-on="on"
                  clearable
                  class="mr-0 pr-0"
                  @click:clear="getCouponsList()"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fromDate"
                color="primary"
                :show-current="new Date().toISOString().substr(0, 10)"
                @input="fromDateMenu = false"
              ></v-date-picker> </v-menu
          ></v-flex>
          <!-- To date -->
          <v-flex xs12 sm12 md5 pl-2>
            <v-menu
              class="d-flex"
              v-model="toDateMenu"
              :close-on-content-click="false"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              color="primary"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="toDate"
                  label="End Date"
                  readonly
                  color="primary"
                  v-on="on"
                  clearable
                  @click:clear="getCouponsList()"
                  :rules="
                    fromDate
                      ? [
                          rules.greaterThanDate(
                            fromDate,
                            toDate
                          ),
                        ]
                      : []
                  "
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="toDate"
                color="primary"
                :show-current="new Date().toISOString().substr(0, 10)"
                @input="toDateMenu = false"
              ></v-date-picker> </v-menu
          ></v-flex>
          <v-flex xs12 sm12 md2>
            <v-btn
              color="primary"
              dark
              @click.stop="getCouponsList()"
              icon
              ><v-icon>search</v-icon></v-btn
            ></v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

    <v-data-table
      :headers="table_headers"
       :loading="loading"
      :items="coupons"
      :pagination.sync="pagination"
      :total-items="total"
      :rowsPerPageItems="rowsPerPageItems"
      item-key="id"
    >
      <template v-slot:items="props">
        <tr style="cursor:pointer"  @click.stop="viewCouponDetail(props.item.id)">
          <td class="body-2">{{ props.item.id }}</td>
          <td>{{ props.item.name ? props.item.name : ''  }}</td>
          <td class="subheading">{{ props.item.code }}
            <v-btn
                slot="activator"
                small
                icon
                dark
                @click.stop="copyToClipboard(props.item.code)"
              >
                <v-icon small color="primary">$vuetify.icons.rms_copy</v-icon>
            </v-btn>
          <td>{{ props.item.discount }}%</td>
          <!-- <td>{{props.item.redeem_limit}}</td> -->
          <td>{{ props.item.no_of_used }}/{{ props.item.redeem_limit }}</td>
          <td>{{ DEFINES.COUPON_TYPES_STR[props.item.type] }}</td>
          <td>
             <v-chip
                v-if="isDateFuture(props.item.start_date)"
                color="error"
                outline
                small
              >
                {{ $t("screener.status.inactive") }}
              </v-chip>
            <v-chip
                v-else-if="isDateFuture(props.item.end_date)"
                color="success"
                outline
                small
              >
                {{$t('screener.status.active')}}
              </v-chip>
              <v-chip v-else color="error" outline small>
                  {{$t('screener.status.expired')}}
              </v-chip>
             </td>
          <td>{{ fmtTime(props.item.start_date) }}</td>
          <td>{{ fmtTime(props.item.end_date) }}</td>
          <td class="text-xs-center">
            <v-tooltip slot="append" top color="white">
              <v-btn
                slot="activator"
                icon
                @click.stop="viewCouponDetail(props.item.id)"
                small
                dark
              >
                <v-icon color="primary">$vuetify.icons.rms_edit</v-icon>
              </v-btn>
              <span class="greyDarken3--text body-1">{{
                $t("rms.tooltip.view")
              }}</span>
            </v-tooltip>

            <ConfirmationDialog
              :desc="'coupon_code.delete.confirmation.dialog.desc'"
              :action="getDialogAction(props.item.id, 'rms_delete', 'error')"
              :headline="'coupon_code.delete.confirmation.dialog.title'"
              :button_type="'icon'"
            ></ConfirmationDialog>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import DEFINES from "@/defines";
import rules from "@/validation";
import i18n from "@/i18n";
import { mapState, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import moment from "moment";
import CouponCreate from "./CouponCreateDialog";
import { utcToTz, isDateFuture } from "@/helper";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "CouponList",
  async beforeRouteEnter(to, from, next) {
    await next(vm => {
      vm.getCouponsList();
    });
  },
  components: {
    CouponCreate,
    ConfirmationDialog
  },
  data() {
    return {
      rules,
      dialog: false,
      moment,
      table_headers: [
        {
          text: i18n.t("coupon_code.list.table.column.id"),
          sortable: true,
          align: "left",
          value: "id",
          tooltip: ""
        },
        {
          text: i18n.t("coupon_code.list.table.column.name"),
          sortable: true,
          align: "left",
          value: "name",
          tooltip: ""
        },
        {
          text: i18n.t("coupon_code.list.table.column.code"),
          sortable: true,
          align: "left",
          value: "code",
          tooltip: ""
        },
        {
          text: i18n.t("coupon_code.list.table.column.discount"),
          sortable: true,
          align: "left",
          value: "discount",
          tooltip: ""
        },
        {
          text: i18n.t("coupon_code.list.table.column.no_of_used"),
          sortable: true,
          align: "left",
          value: "no_of_used",
          tooltip: ""
        },
        {
          text: i18n.t("coupon_code.list.table.column.belongs_to"),
          sortable: false,
          align: "left",
          value: "belongs_to",
          tooltip: ""
        },
        {
          text: i18n.t("coupon_code.list.table.column.status"),
          sortable: false,
          align: "left",
          value: "status",
          tooltip: ""
        },
        {
          text: i18n.t("coupon_code.list.table.column.start_date"),
          align: "left",
          sortable: true,
          value: "start_date",
          tooltip: ""
        },
        {
          text: i18n.t("coupon_code.list.table.column.end_date"),
          align: "left",
          value: "end_date",
          sortable: true,
          tooltip: ""
        },

        {
          text: i18n.t("coupon_code.list.table.column.actions"),
          align: "left",
          value: "action",
          sortable: false,
          tooltip: ""
        }
      ],
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "end_date",
        descending: false,
        page: 1,
        rowsPerPage: 10,
      },
      total:null,
      search: "",
      status:10,
      loading: false,
      fromDateMenu: false,
      toDateMenu: false,
      fromDate: null,
      toDate: null
    };
  },
  watch: {
    pagination: {
      handler:function(newVal,oldVal){
          this.getCouponsList();
      },
      deep: true
    }
  },
  computed: {
    ...mapFields("coupon", {
      coupons: "list"
    }),
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone"
    })
  },
  methods: {
    applySearch() {
      if (this.search.length) this.getCouponsList();
    },
    clearSearch() {
      this.search = "";
      this.getCouponsList();
    },
    // convert utc to comapny timezone
    fmtTime(input) {
      return utcToTz(input, this.timezone, "Do MMM YYYY, h:mm a");
    },
    getDialogAction(update_status, btn_icon, btn_color) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        method: this.onDelete,
        payload: update_status
      };
    },
    async onDelete(coupon_id) {
      await this.$store
        .dispatch("coupon/delete", {
          id: coupon_id
        })
        .then(response => {
          this.getCouponsList();
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("coupon_code.delete.successfully"),
            color: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        });
    },

    copyToClipboard(item) {
      try {
        this.$copyText(item);
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("coupon_code.copied.successfully"),
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },

    async getCouponsList(firstPage = null) {
      try {
        this.loading = true;
        // Pagination
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        var response = await this.$store
          .dispatch("coupon/list",{
            filter:{
                      search: this.search,
                      status: this.status,
                      sort_by: {by: sortBy,dir:descending?'desc':'asc'},
                      perPage:rowsPerPage,
                      fromDate:this.fromDate,
                      toDate:this.toDate
                  },
            page:firstPage ? firstPage:page
          });
        this._syncPagination(response);
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }finally{
        this.loading = false;
      }
    },
     _syncPagination(response) {
        if(!response || response.coupons){
          return;
        }
        this.pagination.page = response.coupons.current_page;
        this.total = response.coupons.total;
    },
    viewCouponDetail(coupon_id) {
      this.$router.push({
        name: "company.coupon.update",
        params: {
          coupon_id: coupon_id
        }
      });
    },
    isDateFuture(date) {
      return isDateFuture(date);
    },
    async exportCoupons() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      const payload = {
          filter:{
            search: this.search,
            status: this.status,
            sort_by: {
              by: sortBy,
              dir:descending?'desc':'asc'
            },
            fromDate:this.fromDate,
            toDate:this.toDate
          }
        };
      await this.$store.dispatch('coupon/export',payload)
        .then((response) => {
          this.$store.dispatch('app/showMessage', {
            message: i18n.t('screener.coupons.report_email.msg'),
            color: 'success',
          });
        })
        .catch((error) => {
          this.$store.dispatch('app/showMessage', {
            message: error.message,
            color: 'error',
          });
      });
    },
  }
};
</script>


